import { useMemo } from 'react';
import Helmet from '../lib/Helmet';
import * as HL from '../lib/heatLoad';
import { CATALOGUE } from '../data/catalogue';
import { PRICES, STOCK } from '../data/pricing';
import { SERIES } from '../data/highlights';
import { STATIONS } from '../data/indiaClimate';
import { AC_SPECS } from '../data/acSpecs';
import { roomACs, roomComparison } from '../data/roomDay';
import {
  GUIDE_SEO, GUIDE_UPDATED, SOURCES, TWO_ROOMS, pickGuideModels, twoRooms, inverterContent, usedSources,
} from '../data/guideInverter';
import { GuideHeader, GuideBody } from '../components/guide/GuideParts';
import TwoRooms from '../components/guide/TwoRooms';

// Route: /blog/inverter-vs-non-inverter-ac — AC guide 1, rebuilt 20 Oct 2026
// to GUIDES_PLAYBOOK.md section 3: Saheb's answer first, the two-rooms
// animation, the simple table, pros and cons, short parts, questions. Every
// word comes from inverterContent() in data/guideInverter.js, which the copy
// for Google (scripts/guide-pages.js) reads too.

export default function InverterGuide() {
  const { c, rooms, S } = useMemo(() => {
    const g = pickGuideModels({ catalogue: CATALOGUE, prices: PRICES, stock: STOCK, series: SERIES });
    const acs = roomACs({ catalogue: CATALOGUE, prices: PRICES, stock: STOCK, series: SERIES, specs: AC_SPECS });
    const pair = [acs.fixed, acs.three];
    const r = twoRooms(TWO_ROOMS.map((x) => roomComparison(HL, STATIONS[x.room.city], x.room, pair)), acs.fixed, acs.three);
    const content = inverterContent(g, r);
    return { c: content, rooms: r, S: usedSources(SOURCES, content) };
  }, []);

  return (
    <>
      <Helmet>
        <title>{GUIDE_SEO.title}</title>
        <meta name="description" content={GUIDE_SEO.meta} />
        <meta property="og:title" content={GUIDE_SEO.title} />
        <meta property="og:description" content={GUIDE_SEO.meta} />
      </Helmet>
      <main className="bg-white pb-16 pt-16 lg:pt-20">
        <article className="mx-auto max-w-[760px] px-4 text-base leading-relaxed text-gray-900">
          <GuideHeader seo={GUIDE_SEO} updated={GUIDE_UPDATED} crumb={GUIDE_SEO.crumb} />
          <GuideBody c={c} sources={S} current="inverter-vs-non-inverter-ac" ctaSource="guide_inverter"
            watch={<TwoRooms rooms={rooms} watch={c.watch} sources={S} />} />
        </article>
      </main>
    </>
  );
}
